import * as React from 'react';

import { sidebarPrice } from './constants';
import type { ReserveBarTicketType } from './constants';

/**
 * **The head of the event page's sidebar** — `Web App.dc.html` §2.2: the price at
 * `800/var(--text-2xl)` in `--text-strong`, baseline-aligned with *"per seat"* at
 * `var(--text-sm)` in `--text-muted`, space between (`MEM-056` AC-4).
 *
 * Every string is the server's rendering or a word from {@link sidebarPrice}; nothing here
 * formats an amount (`docs/standards/money-formatting.md#which-side-formats`).
 *
 * On a phone it is the first line of the same card, inline after the location, and the reserve
 * bar pinned at the foot of the screen carries the price again — that bar is what `MEM-020` AC-1
 * describes, and it has to stand on its own when this line is scrolled out of view.
 */
export function EventPricePanel({
  ticketTypes,
}: {
  readonly ticketTypes: ReadonlyArray<ReserveBarTicketType>;
}): React.ReactElement {
  const price = sidebarPrice(ticketTypes);
  return (
    <div className="flex items-baseline justify-between gap-3" data-testid="event-price">
      <span className="font-brand text-2xl font-black text-foreground">{price.amount}</span>
      {price.unit === null ? null : (
        <span className="text-sm text-muted-foreground">{price.unit}</span>
      )}
    </div>
  );
}
